import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'offers/gateways/range_tables',
  label: 'Faixas de Gateway',
  actions: ['list'],
  onlyPermission: true,
  parentName: 'financial'
};

export default generateResources(resource);
